/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_Key_HelpInputs */



/**
* | output |
* | --- |
* | "You'll find it in your purchase email. This computer must be connected to the internet to activate." |
*
* @param {License_Key_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_key_help = /** @type {((inputs?: License_Key_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_Key_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Elle figure dans l'e-mail de votre achat. Cet ordinateur doit être connecté à Internet pour l'activation.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie finden ihn in Ihrer Kaufbestätigung. Dieser Computer braucht zum Aktivieren eine Internetverbindung.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La trovi nell'email di acquisto. Questo computer deve essere connesso a Internet per l'attivazione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ключ указан в письме о покупке. Для активации компьютер должен быть подключён к интернету.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La encontrarás en el correo de tu compra. Este equipo debe estar conectado a Internet para activarla.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("可在购买邮件中找到。激活时此电脑需要连接互联网。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("購入時のメールに記載されています。アクティベーションにはこのコンピューターのインターネット接続が必要です。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह आपकी खरीद ईमेल में है। सक्रिय करने के लिए इस कंप्यूटर का इंटरनेट से जुड़ा होना ज़रूरी है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Encontra-a no email da compra. Este computador tem de estar ligado à Internet para ativar.")
	return /** @type {LocalizedString} */ ("You'll find it in your purchase email. This computer must be connected to the internet to activate.")
});